const config = {
    host : 'https://message-frame-api-obstt7aq3q-uc.a.run.app'
}
export default config;